<template>
  <div class="addjob-form">
    <el-dialog title="增加职务" :visible="addjobShow" width="30%" @close="dialogClose" @open="dialogOpen">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="职务名称">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="权限字符">
          <el-input
            v-model="form.permission"
            placeholder="请输入权限字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色顺序">
          <el-input v-model="form.order" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.menuStatus">
            <el-radio label="正常"></el-radio>
            <el-radio label="停用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="展开/折叠" name="type"></el-checkbox>
            <el-checkbox label="全选/全不选" name="type"></el-checkbox>
            <el-checkbox label="父子联动" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
      <div class="btns">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["addjobShow"],
  data() {
    return {
      form: {
        name: "",
        // permission: "",
        // menuStatus: "正常",
        // type: [],
        // order: 0
      },
    };
  },
  methods: {
    confirm() {
      this.$emit("addConfirm", this.form);
    },
    dialogClose() {
      this.$emit("update:addjobShow", false);
    },
    dialogOpen() {
      this.form.name = "";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./addJob.scss";
</style>